import { useMutation } from "@tanstack/react-query";
import { AddPhotoImageData } from "common/types";
import User from "../../types/user";
import { postFeedbackDesktop } from "../../apis/feedback";

export function useFeedbackTicketDesktop() {
  const { mutate, error, status, data } = useMutation({
    mutationFn: ({
      accessToken,
      notes,
      images,
    }: {
      accessToken: string;
      notes: string;
      images: AddPhotoImageData[];
    }) => {
      return postFeedbackDesktop(accessToken, notes, images);
    },
    onSuccess: () => {},
  });
  return { mutate, error, isPending: status === "pending", data };
}
